// 接続状態の「判定の値」だけを持つ層 (2026-08-23)。**環境に一切触らない**。
//
// 判定の中身と、それをどう決めるか (navigator / イベント / 往復) は
// connectivityStore.ts が持つ。ここを分けてあるのは分離が綺麗だからではなく、
// **型検査の構造的な制約**である:
//
//   tsconfig.functions.json (lib は ES2022 だけ / @cloudflare/workers-types)
//     → functions/api/sessions/__tests__/integration.test.ts
//     → src/storage/sessionUploader.ts
//     → src/storage/pendingUploads.ts
//
// つまり pendingUploads は DOM の無いプロジェクトからも型検査される。そこから
// window / document / fetch の cache オプションに触るモジュールを import すると
// `Cannot find name 'window'` で pnpm typecheck が落ちる (2026-08-23 に実測)。
// 再送 gate はバナーと同じ判定を使う必要がある (原則 4 — アプリの中に「オンライン」の
// 定義が 2 つあると必ず drift する) ので、値だけをこちらに置いて共有する。
//
// **ここに環境アクセスを足さないこと。** 足した瞬間に pendingUploads 経由で
// worker 側の型検査が落ちる (壊れ方は分かりやすいが、直し方はこの分割に戻ることになる)。

export type ConnectivityVerdict = "online" | "offline" | "checking";

let verdict: ConnectivityVerdict = "checking";
const listeners = new Set<() => void>();

/**
 * useSyncExternalStore の契約上、ここは**キャッシュ済みの値をそのまま返す**必要がある。
 * navigator.onLine をここで読むと、呼ばれるたびに違う値を返しうるうえ
 * 「購読していないのに読める」形になり、判定が 2 箇所に散る。
 */
export function getConnectivitySnapshot(): ConnectivityVerdict {
  return verdict;
}

/**
 * 「確信を持ってオフライン」か。checking (判定中) では false を返す。
 *
 * pendingUploads の再送 gate が使う。判定が付く前に送るのを止めると、
 * まさに 2026-08-23 のような誤検知のときに、バナーが誤って出るのと同時に
 * 前回セッションで送れなかったログの再送まで黙って止まる。
 */
export function isConfirmedOffline(): boolean {
  return verdict === "offline";
}

export function setConnectivityVerdict(next: ConnectivityVerdict): void {
  if (verdict === next) return;
  verdict = next;
  for (const listener of listeners) listener();
}

/** 追加後の購読者数を返す (1 なら最初の購読者)。 */
export function addConnectivityListener(listener: () => void): number {
  listeners.add(listener);
  return listeners.size;
}

/** 削除後の購読者数を返す (0 なら最後の購読者が外れた)。 */
export function removeConnectivityListener(listener: () => void): number {
  listeners.delete(listener);
  return listeners.size;
}
